import { IPromise, IQService } from "angular";
import { clone, cloneDeep } from "lodash";
import {
  IHasResponseStatus,
  ServiceResponse,
} from "../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { CloneMachineResponse, Machine } from "../models/machine";
import { MachineConfiguration } from "../models/machineConfiguration";

export const vsName = "cloneAndConversionService";

export class CloneAndConversionService<
  TMachine extends Machine<TMachineConfiguration>,
  TMachineConfiguration extends MachineConfiguration
> {
  static $inject = [ServerUtilityName, "$q"];

  constructor(
    protected readonly serverUtility: ServerUtility,
    protected readonly $q: IQService
  ) {}

  getConversionConfiguration(
    currentConfiguration: TMachineConfiguration,
    modelMachineId?: number,
    modelConfigurationId?: number
  ): IPromise<TMachineConfiguration> {
    if (modelConfigurationId == undefined && modelMachineId !== undefined)
      throw new Error("Must provide model machine configuration id");

    const cloneConfigurationRequest =
      modelMachineId !== undefined && modelConfigurationId !== undefined
        ? this.getCloneConfiguration(modelMachineId, modelConfigurationId).then(
            (r) => r.Configuration
          )
        : this.$q.when(<TMachineConfiguration>{});

    return cloneConfigurationRequest.then((clone) => {
      return this.prepareConversionConfiguration(
        clone,
        cloneDeep(currentConfiguration)
      );
    });
  }

  protected prepareCloneMachine(cloneMachine: TMachine): TMachine {
    cloneMachine.SerialNumber = undefined;
    return cloneMachine;
  }

  protected prepareConversionConfiguration(
    cloneConfiguration: TMachineConfiguration,
    currentConfiguration: TMachineConfiguration
  ): TMachineConfiguration {
    return {
      ...cloneConfiguration,
      Property: currentConfiguration.Property,
      PropertyId: currentConfiguration.PropertyId,
      Section: currentConfiguration.Section,
      Bank: currentConfiguration.Bank,
      Position: currentConfiguration.Position,
      Status: currentConfiguration.Status,
      MachineArea: currentConfiguration.MachineArea,
      MachineAreaId: currentConfiguration.MachineAreaId,
      MachineBankConfig: currentConfiguration.MachineBankConfig,
      MachineBankConfigId: currentConfiguration.MachineBankConfigId,
      ChangeType: "Conversion",
    };
  }

  protected prepareCloneConfiguration(
    cloneConfiguration: TMachineConfiguration
  ): TMachineConfiguration {
    cloneConfiguration.SlotNumber = undefined;
    return cloneConfiguration;
  }

  getCloneConfiguration(
    machineId: number,
    machineConfigurationId?: number
  ): IPromise<CloneMachineResponse<TMachine, TMachineConfiguration>> {
    return this.serverUtility
      .sendApiRequest<CloneMachineResponse<TMachine, TMachineConfiguration>>({
        url: `/api/machines/${machineId}/clone`,
        method: "get",
        params: {
          machineConfigurationId,
        },
      })
      .then((response) => {
        const cloneConfiguration = this.prepareCloneConfiguration(
          response.Configuration
        );
        const cloneMachine = this.prepareCloneMachine(response.Machine);
        return {
          Configuration: cloneConfiguration,
          Machine: cloneMachine,
        };
      });
  }
}
